import React from 'react';
import GridCell from './GridCell';

const GridGroupRow = (props) => {
  const mapWithRowSpan = (column, index) => {
    if (props.rowWithGroupCell && column.field === props.gridConfig.groupField) {
      return <GridCell column={column} key={`grid-cell-key-${index}`} {...props} />;
    } else if (!props.rowWithGroupCell && column.field === props.gridConfig.groupField) {
      return null;
    }
    return (
      <GridCell
        column={column}
        row={props.row}
        onChangeBodyClass={props.onChangeBodyClass}
        key={`grid-cell-key-${index}`}
      />
    );
  };

  return (
    <tr className="base-tr">
      {props.columns.map((column, index) => {
        if (props.withRowSpan) {
          return mapWithRowSpan(column, index);
        }
        return <GridCell column={column} key={`grid-cell-key-${index}`} {...props} />;
      })}
    </tr>
  );
};

export default GridGroupRow;



// WEBPACK FOOTER //
// ./src/common/core/grid/GridGroupRow.jsx